

























































































































































import { State, namespace } from 'vuex-class';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import ColorPickerInput from '@/components/ColorPickerInput.vue';
import Branding, { BrandingData, BrandStyles, BrandStylesDefault } from '@/views/branding/Branding';

const VisitManagement = namespace('visitManagement');

@Component({
  components: {
    ColorPickerInput
  }
})
export default class BrandingEdit extends Vue {

  @Prop({ default: () => new Branding({}) })
  private value!: BrandingData;
  private form: BrandingData = this.value ? {
    ...this.value,
    logo: this.value.logoUrl,
    kioskBackground: this.value.kioskBackgroundUrl,
    kioskLogo: this.value.kioskLogoUrl
  } : {}

  private customCSS: string | null = null;
  private componentKey: number = 0;
  private stylesTabIndex: number = 0;
  private brandStyles: BrandStyles = new BrandStyles();

  private customTextEditToolbar = [
    ['bold', 'italic', 'underline'],
    ['link'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [
      { align: '' },
      { align: 'center' },
      { align: 'right' }
    ],
    ['clean']
  ]

  public resetColors (): void {
    Object.assign(this.brandStyles, BrandStylesDefault);
    this.$forceUpdate();
    this.componentKey += 1;
  }

  public saveChanges (): void {
    if (this.stylesTabIndex === 1) {
      this.form.css = this.customCSS;
    } else if (this.stylesTabIndex === 0) {
      this.form.css = JSON.stringify(this.brandStyles);
    }

    this.$store
      .dispatch('visitManagement/updateBranding', this.form)
      .then(result => {
        this.$emit('success', result);
      })
      .catch((err) => {
        console.error(err);
        return false;
      });
  }

  public checkCSSData (): void {
    const { css } = this.form
    if (css) {
      try {
        this.brandStyles = JSON.parse(css);
        console.log('brandstyles', this.brandStyles)
        if (!this.brandStyles.kioskBody) {
          this.resetColors();
        }
      } catch (ex) {
        this.customCSS = css;
        this.stylesTabIndex = 1;
      }
    }
  }

  async created () {
    this.checkCSSData()
  }
}
